import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import {
    getLanguageCodeFromSession,
    GetLocalizationControlsJsonDataForScreen,
    replaceLoclizationLabel,
    setLanguageCodeInSession
} from '../../../helpers/CommonHelper';

import GlobalEnums from '../../../helpers/GlobalEnums';
import Wishlist from '../modal/Wishlist';

const TopHeader = () => {

    const [display, setDisplay] = useState(false);
    const [langCode, setLangCode] = useState('');
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);

    const handleWishlist = () => {
        setDisplay(!display);
    };

    const handleLangCodeInSession = async (value) => {
        try {
            await setLanguageCodeInSession(value);
            setLangCode(value);

            window.location.href = `/${value}/`;
        } catch (error) {
            console.error('Language change error:', error);
        }
    };

    useEffect(() => {

        const dataOperationFunc = async () => {

            try {

                const lnCode = getLanguageCodeFromSession();

                setLangCode(lnCode || 'en');

                const arryRespLocalization =
                    await GetLocalizationControlsJsonDataForScreen(
                        GlobalEnums.Entities["TopHeader"],
                        null
                    );

                if (
                    arryRespLocalization &&
                    Array.isArray(arryRespLocalization) &&
                    arryRespLocalization.length > 0
                ) {
                    setLocalizationLabelsArray(arryRespLocalization);
                }

            } catch (error) {
                console.error('TopHeader localization error:', error);
            }
        };

        dataOperationFunc();

    }, []);

    const getLabel = (defaultText, id) => {

        if (
            LocalizationLabelsArray &&
            LocalizationLabelsArray.length > 0
        ) {
            return replaceLoclizationLabel(
                LocalizationLabelsArray,
                defaultText,
                id
            );
        }

        return defaultText;
    };

    const currentLanguage =
        getLanguageCodeFromSession() || langCode || 'en';

    return (
        <>
            {/* =====================================================
                TOP HEADER
            ====================================================== */}

            <div
                style={{
                    width: '100%',
                    background: '#131921',
                    color: '#ffffff',
                    borderBottom: '1px solid rgba(255,255,255,0.10)',
                    position: 'relative',
                    zIndex: 999
                }}
            >

                <div
                    style={{
                        width: '100%',
                        maxWidth: '1440px',
                        minHeight: '52px',
                        margin: '0 auto',
                        padding: '0 24px',
                        boxSizing: 'border-box',

                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '20px'
                    }}
                >

                    {/* =================================================
                        LEFT MENU
                    ================================================= */}

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: 0,
                            overflowX: 'auto',
                            scrollbarWidth: 'none'
                        }}
                    >

                        {/* ABOUT */}

                        <Link
                            to={`/${currentLanguage}/about`}
                            id="lbl_thead_about"
                            style={{
                                height: '52px',
                                padding: '0 13px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '7px',
                                color: '#e7e7e7',
                                textDecoration: 'none',
                                fontSize: '13px',
                                fontWeight: '500',
                                whiteSpace: 'nowrap',
                                transition: 'all 0.2s ease'
                            }}
                        >

                            <span
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#febd69'
                                }}
                            >
                                <i className="far fa-building"></i>
                            </span>

                            {getLabel(
                                'About',
                                'lbl_thead_about'
                            )}

                        </Link>


                        {/* DIVIDER */}

                        <span
                            style={{
                                width: '1px',
                                height: '22px',
                                background: 'rgba(255,255,255,0.15)',
                                flexShrink: 0
                            }}
                        />


                        {/* FAQ */}

                        <Link
                            to={`/${currentLanguage}/faq`}
                            id="lbl_thead_faq"
                            style={{
                                height: '52px',
                                padding: '0 13px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '7px',
                                color: '#e7e7e7',
                                textDecoration: 'none',
                                fontSize: '13px',
                                fontWeight: '500',
                                whiteSpace: 'nowrap'
                            }}
                        >

                            <span
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#febd69'
                                }}
                            >
                                <i className="far fa-question-circle"></i>
                            </span>

                            {getLabel(
                                "FAQ's",
                                'lbl_thead_faq'
                            )}

                        </Link>


                        {/* DIVIDER */}

                        <span
                            style={{
                                width: '1px',
                                height: '22px',
                                background: 'rgba(255,255,255,0.15)'
                            }}
                        />


                        {/* CONTACT */}

                        <Link
                            to={`/${currentLanguage}/contact-us`}
                            id="lbl_thead_contct"
                            style={{
                                height: '52px',
                                padding: '0 13px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '7px',
                                color: '#e7e7e7',
                                textDecoration: 'none',
                                fontSize: '13px',
                                fontWeight: '500',
                                whiteSpace: 'nowrap'
                            }}
                        >

                            <span
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#febd69'
                                }}
                            >
                                <i className="far fa-envelope"></i>
                            </span>

                            {getLabel(
                                'Contact',
                                'lbl_thead_contct'
                            )}

                        </Link>


                        {/* DIVIDER */}

                        <span
                            style={{
                                width: '1px',
                                height: '22px',
                                background: 'rgba(255,255,255,0.15)'
                            }}
                        />


                        {/* BECOME SELLER */}

                        <Link
                            to={`/${currentLanguage}/become-seller`}
                            id="lbl_thead_seller"
                            style={{
                                height: '52px',
                                padding: '0 13px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '7px',
                                color: '#ffffff',
                                textDecoration: 'none',
                                fontSize: '13px',
                                fontWeight: '600',
                                whiteSpace: 'nowrap'
                            }}
                        >

                            <span
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#ff9900'
                                }}
                            >
                                <i className="fas fa-store"></i>
                            </span>

                            {getLabel(
                                'Become Seller',
                                'lbl_thead_seller'
                            )}

                        </Link>

                    </div>


                    {/* =================================================
                        RIGHT MENU
                    ================================================= */}

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexShrink: 0
                        }}
                    >

                        {/* WISHLIST */}

                        <button
                            type="button"
                            onClick={handleWishlist}
                            aria-label="Wishlist"
                            style={{
                                height: '52px',
                                padding: '0 15px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                border: 'none',
                                background: 'transparent',
                                color: '#ffffff',
                                fontSize: '13px',
                                fontWeight: '600',
                                cursor: 'pointer'
                            }}
                        >

                            <span
                                style={{
                                    width: '27px',
                                    height: '27px',
                                    position: 'relative',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '50%',
                                    background: 'rgba(255,153,0,0.12)',
                                    color: '#ff9900'
                                }}
                            >

                                <i className="far fa-heart"></i>

                                <span
                                    style={{
                                        position: 'absolute',
                                        top: '1px',
                                        right: '1px',
                                        width: '6px',
                                        height: '6px',
                                        borderRadius: '50%',
                                        background: '#ff4d4f',
                                        border: '1px solid #131921'
                                    }}
                                />

                            </span>

                            <span id="lbl_thead_wishlist">
                                {getLabel(
                                    'Wishlist',
                                    'lbl_thead_wishlist'
                                )}
                            </span>

                        </button>


                        {/* DIVIDER */}

                        <span
                            style={{
                                width: '1px',
                                height: '22px',
                                background: 'rgba(255,255,255,0.15)'
                            }}
                        />


                        {/* LANGUAGE */}

                        <div
                            style={{
                                height: '52px',
                                padding: '0 13px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '7px',
                                position: 'relative',
                                color: '#ffffff'
                            }}
                        >

                            <i
                                className="fas fa-globe"
                                style={{
                                    color: '#febd69',
                                    fontSize: '14px'
                                }}
                            />

                            <select
                                value={langCode}
                                onChange={(e) =>
                                    handleLangCodeInSession(
                                        e.target.value
                                    )
                                }
                                aria-label="Language"
                                style={{
                                    appearance: 'none',
                                    WebkitAppearance: 'none',
                                    border: 'none',
                                    outline: 'none',
                                    background: 'transparent',
                                    color: '#ffffff',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    padding: '4px 20px 4px 2px'
                                }}
                            >

                                <option
                                    value="en"
                                    style={{
                                        background: '#ffffff',
                                        color: '#222222'
                                    }}
                                >
                                    English
                                </option>

                                <option
                                    value="ta"
                                    style={{
                                        background: '#ffffff',
                                        color: '#222222'
                                    }}
                                >
                                    தமிழ்
                                </option>

                                <option
                                    value="hi"
                                    style={{
                                        background: '#ffffff',
                                        color: '#222222'
                                    }}
                                >
                                    हिन्दी
                                </option>

                                <option
                                    value="kn"
                                    style={{
                                        background: '#ffffff',
                                        color: '#222222'
                                    }}
                                >
                                    ಕನ್ನಡ
                                </option>

                                <option
                                    value="te"
                                    style={{
                                        background: '#ffffff',
                                        color: '#222222'
                                    }}
                                >
                                    తెలుగు
                                </option>

                                <option
                                    value="ml"
                                    style={{
                                        background: '#ffffff',
                                        color: '#222222'
                                    }}
                                >
                                    മലയാളം
                                </option>

                            </select>

                            <i
                                className="fas fa-chevron-down"
                                style={{
                                    position: 'absolute',
                                    right: '7px',
                                    fontSize: '9px',
                                    color: '#b8b8b8',
                                    pointerEvents: 'none'
                                }}
                            />

                        </div>

                    </div>

                </div>

            </div>


            {/* =====================================================
                PROMOTION BAR
            ====================================================== */}

            <div
                style={{
                    width: '100%',
                    background:
                        'linear-gradient(90deg,#fff8e7 0%,#fffdf7 50%,#fff8e7 100%)',
                    borderBottom: '1px solid #ead9b8',
                    overflow: 'hidden'
                }}
            >

                <div
                    style={{
                        minHeight: '40px',
                        maxWidth: '1440px',
                        margin: '0 auto',
                        padding: '0 24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        color: '#4a3a22',
                        fontSize: '13px',
                        boxSizing: 'border-box'
                    }}
                >

                    <div
                        style={{
                            width: '25px',
                            height: '25px',
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '50%',
                            background: '#ff9900',
                            color: '#ffffff',
                            fontSize: '11px'
                        }}
                    >
                        <i className="fas fa-bolt"></i>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            gap: '7px',
                            lineHeight: '1.5',
                            textAlign: 'center'
                        }}
                    >

                        <strong style={{ color: '#9b3d00' }}>
                            Be the first to see what's in store!
                        </strong>

                        <span style={{ color: '#c59a52' }}>
                            •
                        </span>

                        <span>
                            Join us for the opening of our new shop
                            and get exclusive discounts today.
                        </span>

                        <span style={{ color: '#c59a52' }}>
                            •
                        </span>

                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '5px',
                                color: '#333333'
                            }}
                        >

                            <i
                                className="fas fa-phone-alt"
                                style={{ color: '#0a7c3b' }}
                            />

                            Bulk Orders:

                            <strong style={{ color: '#0a7c3b' }}>
                                9597172992
                            </strong>

                        </span>

                    </div>

                </div>

            </div>


            {/* =====================================================
                WISHLIST MODAL
            ====================================================== */}

            {display && (
                <Wishlist
                    handleWishlist={handleWishlist}
                />
            )}

        </>
    );
};

export default TopHeader;

